"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import { useKeyPressEvent } from "react-use";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import MemesArtSubmissionContainer from "./submission/MemesArtSubmissionContainer";
interface MemesArtSubmissionModalProps {
  readonly isOpen: boolean;
  readonly wave: ApiWave;
  readonly onClose: () => void;
  readonly sourceDrop?: ExtendedDrop | undefined;
  readonly onSourceDropDeleted?: (() => void) | undefined;
}
const MemesArtSubmissionModal: React.FC<MemesArtSubmissionModalProps> = t0 => {
  const $ = _c(10);
  const {
    isOpen,
    wave,
    onClose,
    sourceDrop,
    onSourceDropDeleted
  } = t0;
  const modalRef = useRef(null);
  let t1;
  if ($[0] !== onClose) {
    t1 = () => onClose();
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useKeyPressEvent("Escape", t1);
  if (!isOpen) {
    return null;
  }
  let t2;
  if ($[2] !== isOpen || $[3] !== onClose || $[4] !== onSourceDropDeleted || $[5] !== sourceDrop || $[6] !== wave) {
    t2 = isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="tailwind-scope tw-fixed tw-inset-0 tw-z-[1000] tw-overflow-hidden tw-bg-gray-600/80 tw-backdrop-blur-sm" onClick={onClose}><div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center md:tw-inset-4"><motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease: "easeOut"
        }} data-testid="memes-art-submission-modal-panel" className="tw-flex tw-h-[100dvh] tw-max-h-[100dvh] tw-w-full tw-max-w-screen-xl tw-flex-col md:tw-h-full md:tw-max-h-none" ref={modalRef} onClick={_temp}><div className="tw-flex tw-h-full tw-flex-col tw-overflow-hidden"><MemesArtSubmissionContainer onClose={onClose} wave={wave} sourceDrop={sourceDrop} onSourceDropDeleted={onSourceDropDeleted} /></div></motion.div></div></motion.div>;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = onSourceDropDeleted;
    $[5] = sourceDrop;
    $[6] = wave;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = createPortal(<AnimatePresence>{t2}</AnimatePresence>, document.body);
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default MemesArtSubmissionModal;
function _temp(e) {
  e.stopPropagation();
}